import { useEffect } from "react";

/**
 * Injects a JSON-LD script into the document head keyed by `id`.
 * Removes/updates the script on unmount so per-route schemas don't accumulate.
 */
export default function JsonLd({ id, data }) {
  useEffect(() => {
    if (!data) return undefined;
    const scriptId = `jsonld-${id}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const remove = document.getElementById(scriptId);
      if (remove) remove.remove();
    };
  }, [id, data]);
  return null;
}
